(function () {
    const KEY = 'sherbet:recently-viewed';
    const MAX_STORE = 24;

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(arr) {
      try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX_STORE))); } catch (e) {}
    }

    // Track on every product page render, handle comes from the section data attr
    // when it exists, or from <body class="template-product"> + URL.
    const tracker = document.querySelector('[data-recently-viewed]');
    let currentHandle = tracker && tracker.dataset.currentHandle;
    if (!currentHandle && document.body.classList.contains('template-product')) {
      const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) currentHandle = m[1];
    }
    if (currentHandle) {
      const list = read();
      const filtered = list.filter(function (h) { return h !== currentHandle; });
      filtered.unshift(currentHandle);
      write(filtered);
    }

    document.querySelectorAll('[data-recently-viewed]').forEach(function (root) {
      const grid = root.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      const limit = parseInt(root.dataset.limit, 10) || 6;
      const exclude = root.dataset.currentHandle || '';
      const handles = read().filter(function (h) { return h !== exclude; }).slice(0, limit);
      if (!handles.length) return;

      // Fetch each product card via the search endpoint with a card-product-only template.
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '?view=quick-view', {
          headers: { 'Accept': 'text/html' }
        })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            // Extract title + image + price from the quick-view payload
            const product = doc.querySelector('[data-quick-view-product]');
            if (!product) return null;
            // Be defensive, match by class first, then any <img> inside the media wrapper, then any <img> inside the product node.
            const image = product.querySelector('.quick-view__image')
                       || product.querySelector('.quick-view__media img')
                       || product.querySelector('img');
            const title = product.querySelector('.quick-view__title-link');
            const priceNow = product.querySelector('.quick-view__price-now');
            const priceWas = product.querySelector('.quick-view__price-was');
            return {
              handle: handle,
              url: title ? title.getAttribute('href') : '/products/' + handle,
              title: title ? title.textContent.trim() : handle,
              image: image ? image.getAttribute('src') : '',
              imageAlt: image ? image.getAttribute('alt') : '',
              priceNow: priceNow ? priceNow.textContent.trim() : '',
              priceWas: priceWas ? priceWas.textContent.trim() : '',
              cardColor: product.getAttribute('data-card-color') || ''
            };
          })
          .catch(function () { return null; });
      })).then(function (products) {
        const valid = products.filter(Boolean);
        if (!valid.length) return;
        root.hidden = false;

        const ratio = root.dataset.imageRatio || 'square';
        const style = root.dataset.cardStyle || 'standard';

        valid.forEach(function (p) {
          const a = document.createElement('a');
          a.className = 'card-product card-product--ratio-' + ratio + ' card-product--style-' + style;
          a.href = p.url;
          if (p.cardColor) a.style.setProperty('--card-bg', p.cardColor);

          const media = document.createElement('div');
          media.className = 'card-product__media';
          if (p.image) {
            const img = document.createElement('img');
            img.className = 'card-product__image card-product__image--primary';
            img.src = p.image;
            img.alt = p.imageAlt || p.title;
            img.loading = 'lazy';
            media.appendChild(img);
          }

          const info = document.createElement('div');
          info.className = 'card-product__info';
          const titleEl = document.createElement('span');
          titleEl.className = 'card-product__title';
          titleEl.textContent = p.title;
          const priceEl = document.createElement('span');
          priceEl.className = 'card-product__price';
          if (p.priceWas) {
            const now = document.createElement('span');
            now.className = 'card-product__price-now';
            now.textContent = p.priceNow;
            const was = document.createElement('s');
            was.className = 'card-product__price-was';
            was.textContent = p.priceWas;
            priceEl.appendChild(now);
            priceEl.appendChild(was);
          } else {
            priceEl.textContent = p.priceNow;
          }
          info.appendChild(titleEl);
          info.appendChild(priceEl);

          a.appendChild(media);
          a.appendChild(info);
          grid.appendChild(a);
        });
      });
    });
  })();
